import script from "./IDEA_ACTIVITY_UPDATE_DESCRIPTION.vue?vue&type=script&setup=true&lang=ts"
export * from "./IDEA_ACTIVITY_UPDATE_DESCRIPTION.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__